import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import { parseFromTimeString } from "utilities/momentutils";
import OptionalTimePicker from "components/OptionalTimePicker";

const FreefieldTimeSpan = (props: FreefieldInputProps) => {
  const [value, setValue] = React.useState(props.initialValue ? parseFromTimeString(props.initialValue) : undefined);

  const onChange = (newValue: moment.Moment) => {
    setValue(newValue);
    props.onChange(newValue?.format("HH:mm"));
  };

  return <OptionalTimePicker
    value={value}
    onChange={onChange}
  />;
};

export default FreefieldTimeSpan;